var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyNoowner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205,
    height: 122,
    viewBox: "0 0 205 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(26 7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9F0FF",
    d: "M12.819426,-5.17920154e-16 L140.180574,5.17920154e-16 C144.638168,-3.00926524e-16 146.254599,0.464128056 147.884229,1.33566352 C149.513858,2.20719898 150.792801,3.48614185 151.664336,5.11577148 C152.535872,6.74540111 153,8.3618323 153,12.819426 L153,95.180574 C153,99.6381677 152.535872,101.254599 151.664336,102.884229 C150.792801,104.513858 149.513858,105.792801 147.884229,106.664336 C146.254599,107.535872 144.638168,108 140.180574,108 L12.819426,108 C8.3618323,108 6.74540111,107.535872 5.11577148,106.664336 C3.48614185,105.792801 2.20719898,104.513858 1.33566352,102.884229 C0.464128056,101.254599 2.00617683e-16,99.6381677 -3.45280103e-16,95.180574 L3.45280103e-16,12.819426 C-2.00617683e-16,8.3618323 0.464128056,6.74540111 1.33566352,5.11577148 C2.20719898,3.48614185 3.48614185,2.20719898 5.11577148,1.33566352 C6.74540111,0.464128056 8.3618323,3.00926524e-16 12.819426,-5.17920154e-16 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9DBFF",
    d: "M63.6916556,29 L138.308344,29 C140.982901,29 141.952759,29.2784768 142.930537,29.8013981 C143.908315,30.3243194 144.675681,31.0916851 145.198602,32.0694629 C145.721523,33.0472407 146,34.0170994 146,36.6916556 L146,75.3083444 C146,77.9829006 145.721523,78.9527593 145.198602,79.9305371 C144.675681,80.9083149 143.908315,81.6756806 142.930537,82.1986019 C141.952759,82.7215232 140.982901,83 138.308344,83 L63.6916556,83 C61.0170994,83 60.0472407,82.7215232 59.0694629,82.1986019 C58.0916851,81.6756806 57.3243194,80.9083149 56.8013981,79.9305371 C56.2784768,78.9527593 56,77.9829006 56,75.3083444 L56,36.6916556 C56,34.0170994 56.2784768,33.0472407 56.8013981,32.0694629 C57.3243194,31.0916851 58.0916851,30.3243194 59.0694629,29.8013981 C60.0472407,29.2784768 61.0170994,29 63.6916556,29 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9F0FF",
    fillRule: "nonzero",
    d: "M138,41 C139.104569,41 139.999988,41.8954305 139.999988,43 C139.999988,44.1045695 139.104569,45 138,45 C135.563763,45 133.68645,45.9376518 131.213851,48.444229 L130.771096,48.902981 C130.696195,48.9821969 130.62072,49.0628022 130.544643,49.1448128 L130.080706,49.6538697 L129.600887,50.1974267 L129.103775,50.7762549 L128.587961,51.3911252 L128.052036,52.0428085 L126.867258,53.5041388 L126.292714,54.1995701 C126.198457,54.312417 126.104928,54.4237425 126.012094,54.5335582 L125.463178,55.174428 C121.765695,59.4311718 119.127173,61.1890148 115.289258,61.248646 L115.006262,61.2499902 C110.9351,61.2627374 108.667479,60.6431563 105.389603,58.9580911 L104.519647,58.4995018 C101.696018,56.9841139 100.158659,56.4344383 97.3081601,56.2683478 L97.001,56.253 L96.7525037,56.2660656 C93.7860335,56.459162 91.562865,57.525911 88.3513039,59.9347188 L86.3141709,61.4944325 L85.7159116,61.9412816 C85.6528917,61.9875649 85.5905265,62.0330876 85.5283198,62.0782109 C82.8182517,64.0440353 80.6383319,65 78,65 C74.7709691,65 72.9843578,64.0931395 70.6833004,61.8824234 L70.0908231,61.3015949 C68.132031,59.3769632 66.8904778,58.7473204 64.0018547,58.7499991 C62.8972857,58.7510235 62.0010252,57.8564237 61.9999878,56.7518547 C61.9989765,55.6472857 62.8935763,54.7510252 63.9981453,54.7500009 C67.9421845,54.7463434 70.1069956,55.7795683 72.6396867,58.2015569 L73.241155,58.790323 C74.9876906,60.5100336 75.8928175,61 78,61 C79.5448502,61 80.9494068,60.4163173 82.8852084,59.0510309 L83.3506588,58.7155063 L83.9050784,58.3012544 L85.5634641,57.028221 C89.5493751,53.9860421 92.4646293,52.5315903 96.4938612,52.2741915 L96.9147416,52.2518181 L97.0889277,52.251978 C100.747379,52.4148079 102.808267,53.0760954 106.00542,54.7592471 L106.865986,55.2173575 L107.551863,55.5703298 C110.100442,56.8471541 111.79115,57.2600467 115.011629,57.2500338 C117.141929,57.2624205 118.862958,56.3437133 121.204185,53.9093426 L121.636926,53.4498981 C121.856942,53.211695 122.0826,52.9606729 122.314673,52.6963927 L122.7876,52.1500246 L123.279008,51.5675206 L123.790272,50.9481001 L124.665866,49.8674424 C124.870168,49.6148143 125.071099,49.3683631 125.268917,49.1279931 L125.853294,48.42503 C126.141072,48.082574 126.422428,47.7535845 126.698233,47.4377375 L127.2427,46.8234709 C127.421894,46.6244926 127.59888,46.4312594 127.773914,46.2436754 L128.293423,45.6977751 C131.549848,42.3465262 134.195213,41 138,41 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9DBFF",
    d: "M14.6916556,29 L44.3083444,29 C46.9829006,29 47.9527593,29.2784768 48.9305371,29.8013981 C49.9083149,30.3243194 50.6756806,31.0916851 51.1986019,32.0694629 C51.7215232,33.0472407 52,34.0170994 52,36.6916556 L52,93.3083444 C52,95.9829006 51.7215232,96.9527593 51.1986019,97.9305371 C50.6756806,98.9083149 49.9083149,99.6756806 48.9305371,100.198602 C47.9527593,100.721523 46.9829006,101 44.3083444,101 L14.6916556,101 C12.0170994,101 11.0472407,100.721523 10.0694629,100.198602 C9.09168511,99.6756806 8.32431939,98.9083149 7.80139811,97.9305371 C7.27847683,96.9527593 7,95.9829006 7,93.3083444 L7,36.6916556 C7,34.0170994 7.27847683,33.0472407 7.80139811,32.0694629 C8.32431939,31.0916851 9.09168511,30.3243194 10.0694629,29.8013981 C11.0472407,29.2784768 12.0170994,29 14.6916556,29 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9F0FF",
    d: "M29.5,36 C36.4035594,36 42,41.5964406 42,48.5 C42,55.4035594 36.4035594,61 29.5,61 C22.5964406,61 17,55.4035594 17,48.5 C17,41.5964406 22.5964406,36 29.5,36 Z M29.5,41 C25.3578644,41 22,44.3578644 22,48.5 C22,52.6421356 25.3578644,56 29.5,56 C33.6421356,56 37,52.6421356 37,48.5 C37,44.3578644 33.6421356,41 29.5,41 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 10,
    x: 14,
    y: 84,
    fill: "#E9F0FF",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 22,
    y: 82,
    fill: "#E9F0FF",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 15,
    x: 30,
    y: 79,
    fill: "#E9F0FF",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 21,
    x: 38,
    y: 73,
    fill: "#E9F0FF",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 7,
    x: 7,
    y: 18,
    fill: "#C9DBFF",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 7,
    x: 7,
    y: 7,
    fill: "#C9DBFF",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 7,
    x: 40,
    y: 7,
    fill: "#C9DBFF",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 7,
    x: 65,
    y: 7,
    fill: "#C9DBFF",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 5,
    x: 56,
    y: 87,
    fill: "#C9DBFF",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 5,
    x: 56,
    y: 96,
    fill: "#C9DBFF",
    rx: 2.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNoowner);
export default __webpack_public_path__ + "static/media/empty_noowner.84db250f.svg";
export { ForwardRef as ReactComponent };